<template>
  <div v-if="row">
    <input v-if="editable"
           :class="currencyLeft()?'currencyLeftInput':'currencyRightInput'"
           class="valueInputField"
           type="text"
           v-model="row[field]"
           @blur="blurFn()"
    >
    <div :class="currencyLeft()?'currencyLeftText':'currencyRightText'" v-else>
    {{ row[field] }}
  </div>
    <div class="currencySymbol" :style="currencyStyle()">{{ currencySymbol() }}</div>
  </div>
</template>

<script>
import Vue from "vue";

const currencyMap = {
  USD: {left: true, sign: "$"},
  EUR: {left: false, sign: "€"},
  JPY:{left:true,sign: "¥"},
  GBP:{left:true,sign: "£"},
  AUD:{left:true,sign: "A$"},
  CAD:{left:true,sign: "C$"},
  CHF:{left:true,sign: "CHF"},
  CNY:{left:false,sign: "¥"},
  HKD:{left:true,sign: "HK$"},
  NZD:{left:true,sign: "NZ$"},
  SEK:{left:true,sign: "kr"},
  KRW:{left:true,sign: "₩"},
  SGD:{left:true,sign: "S$"},
  NOK:{left:true,sign: "kr"},
  MXN:{left:true,sign: "$"},
  INR:{left:true,sign: "₹"},
  RUB:{left:true,sign: "₽"},
  ZAR:{left:true,sign: "R"},
  TRY:{left:false,sign: "₺"},
  BRL:{left:true,sign: "R$"},
  RON:{left:true,sign: "L"}

}
export default Vue.extend({
  name: "pd-currencyinput",

  data: () => ({}),

  methods: {
    currencyLeft: function () {
      if (currencyMap[this.currency]) {
        return currencyMap[this.currency].left
      }

      return true;
    },

    currencySymbol: function () {
      if(!this.row[this.field]){
        return "";
      }
      if (currencyMap[this.currency]) {
        return currencyMap[this.currency].sign
      }

      return this.currency;
    },

    currencyStyle:function () {
      if(!this.currencyLeft()){
        let text = this.row[this.field];
        if(!text){
          text = " ";
        }
        else{
          text = (""+text);
        }

        let spacing = (text.length * 0.49);
        if(text.indexOf(".")!==-1){
          spacing -=0.2;
        }

        return "left: "+spacing+"rem";
      }
    }

  },
  props: {
    editable: Boolean,
    currency: String,
    field: String,
    row: {
      type: Object,
      default: null
    },
    blurFn:Function
  }
})
</script>

<style scoped>
.currencyLeftInput{
  padding-left: 1rem;
}
.currencyRightInput{
  padding-right: 1rem;
}
.currencyLeftText{
  margin-left: 1rem;
}
.currencyRightText{
  margin-right: 1rem;
}

.valueInputField{
  width:80%
}

.currencySymbol{
  position:relative;
  top:-1rem;
  left: 0;
  width: 0.9rem;
  max-width: 0.9rem;
  min-width: 1px;
  overflow: visible;
  text-align: center;
}
</style>